import { render, staticRenderFns } from "./PositionManage.vue?vue&type=template&id=7c1109d4&scoped=true&"
import script from "./PositionManage.vue?vue&type=script&lang=js&"
export * from "./PositionManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1109d4",
  null
  
)

export default component.exports